import { ColumnFilter } from './ColumnFilter';

function dateFormat(value) {
    let objectDate = new Date(value);
    let day = ("0" + (objectDate.getDate() + 1)).slice(-2);
    let month = ("0" + (objectDate.getMonth() + 1)).slice(-2);
    let year = objectDate.getFullYear();

    return day + "/" + month + "/" + year;
}

export const COLUMNS = [
    {
        Header: 'Technician ID',
        Footer: 'Technician ID',
        accessor: 'TechnicianID',
        Filter: ColumnFilter,
        // disableFilters: true,
    },
    {
        Header: 'اسم الفني',
        Footer: 'First Name',
        accessor: 'FirstName',
        Filter: ColumnFilter,
    },
    {
        Header: 'الكنية',
        Footer: 'Last Name',
        accessor: 'LastName',
        Filter: ColumnFilter,
    },
    {
        Header: 'رقم الهاتف',
        Footer: 'Phone Number',
        accessor: 'Phone',
        Filter: ColumnFilter,
    },
    {
        Header: 'البريد الإلكتروني',
        Footer: 'Email',
        accessor: 'Email',
        Filter: ColumnFilter,
    },
    {
        Header: 'تاريخ التوظيف',
        Footer: 'Hire Date',
        accessor: 'HireDate',
        Cell: ({ value }) => dateFormat(value), // Format the date
        Filter: ColumnFilter,
    },
    {
        Header: 'الراتب',
        Footer: 'Salary',
        accessor: 'Salary',
        Filter: ColumnFilter,
    },
    {
        Header: 'التخصص',
        Footer: 'Specialization',
        accessor: 'Specialization',
        Filter: ColumnFilter,
    },
   
];

export const GROUPED_COLUMNS = [
    {
        Header: 'ID',
        Footer: 'ID',
        accessor: 'TechnicianID',
    },
    {
        Header: 'Name',
        Footer: 'Name',
        columns: [
            {
                Header: 'First Name',
                Footer: 'First Name',
                accessor: 'FirstName',
            },
            {
                Header: 'Last Name',
                Footer: 'Last Name',
                accessor: 'LastName',
            },
        ],
    },
    {
        Header: 'Contact Info',
        Footer: 'Contact Info',
        columns: [
            {
                 Header: 'رقم الهاتف',
                Footer: 'Phone',
                accessor: 'Phone',
            },
            {
                Header: 'البريد الالكتروني',
                Footer: 'Email',
                accessor: 'Email',
            },
        ],
    },
    {
        Header: 'Details',
        Footer: 'Details',
        columns: [
            {
                Header: 'Hire Date',
                Footer: 'Hire Date',
                accessor: 'HireDate',
                Cell: ({ value }) => dateFormat(value), // Format the date
            },
            {
                Header: 'Salary',
                Footer: 'Salary',
                accessor: 'Salary',
            },
            {
                Header: 'Specialization',
                Footer: 'Specialization',
                accessor: 'Specialization',
            },
            {
                Header: 'الحالة',
                Footer: 'Status',
                accessor: 'Status',
            },
        ],
    },
];
